var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLike = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#19AD78",
  d: "M19.3 8.08A3 3 0 0 0 17 7h-4.56L13 5.57A4.13 4.13 0 0 0 9.11 0a1 1 0 0 0-.91.59L5.35 7H3a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h12.73a3 3 0 0 0 2.95-2.46l1.27-7a3 3 0 0 0-.65-2.46M5 18H3a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h2zm13-7.82-1.27 7a1 1 0 0 1-1 .82H7V8.21l2.72-6.12a2.11 2.11 0 0 1 1.38 2.78l-.53 1.43A2 2 0 0 0 12.44 9H17a1 1 0 0 1 .77.36 1 1 0 0 1 .23.82"
})));
export default SvgLike;